// src/services/classAccess.js
// Checks whether a user can access a specific live class
// Access is granted if any of:
//   1. User is admin or friend
//   2. User has an active subscription (classSubscription in publicMetadata)
//   3. User purchased a drop-in for this specific class (classPurchases collection)
//
// Also provides helpers for fetching purchase status

import { db, firebaseEnabled } from './firebase';
import { doc, getDoc, collection, query, where, getDocs } from 'firebase/firestore';

// ── Check if user purchased a specific class ──
export async function hasClassPurchase(userId, classId) {
    if (!firebaseEnabled || !db || !userId || !classId) return false;
    try {
        const snap = await getDoc(doc(db, 'classPurchases', `${userId}_${classId}`));
        return snap.exists();
    } catch (e) { console.error('Error checking class purchase:', e); return false; }
}

// ── Get all class IDs a user has purchased ──
export async function getUserClassPurchases(userId) {
    if (!firebaseEnabled || !db || !userId) return new Set();
    try {
        const q = query(collection(db, 'classPurchases'), where('userId', '==', userId));
        const snap = await getDocs(q);
        return new Set(snap.docs.map((d) => d.data().classId));
    } catch (e) { console.error('Error fetching class purchases:', e); return new Set(); }
}

// ── Check full access (admin, friend, subscriber, or purchased this class) ──
export function canAccessClass(user, classId, purchasedClassIds) {
    if (!user) return false;
    const role = user.publicMetadata?.role;
    if (role === 'admin' || role === 'friend') return true;
    if (user.publicMetadata?.classSubscription) return true;
    if (purchasedClassIds?.has(classId)) return true;
    return false;
}

// ── Check if user has an active subscription ──
export function hasActiveSubscription(user) {
    if (!user) return false;
    return !!user.publicMetadata?.classSubscription;
}
